<template>
  <div class="resister-content">
    <!-- <div class="hearder"> -->
    <!-- <a class="cursor" @click="util.topage('home')"><img src="@/assets/images/icon/home_icon_251286.png"/></a> -->
    <!-- <a class="cursor"><img src="@/assets/images/icon/smiled_emoji_icon_250933.png" /></a> -->
    <!-- </div> -->
    <div class="btcCenter">
      <img src="@/assets/images/base/logo.png" />
      <p>&nbsp;data platform</p>
      <!-- <img src="@/assets/images/base/logo.png" />
      <p><span style="color: orange;">zengo</span></p>-->
    </div>
    <!-- <div class="title">zengo Digital Trading Platform</div> -->
    <div class="box">
      <ul>
        <!-- <li>
                <div class="icon-input"><img src="@/assets/images/icon/user_icon_251290.png"/></div>
                <input type="text" v-model="email" placeholder="Please enter your email"/>
            </li> -->
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/user_icon_251290.png" /></div>
          <input type="text" v-model="phone" v-on:input="phone_input" placeholder="Please Enter Your Account" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye"><img :src="fristeyepic" /></div>
          <input :type="fristtype" v-model="password" placeholder="Please Enter New Login Password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye2"><img :src="fristeyepic2" /></div>
          <input :type="fristtype2" v-model="password2" placeholder="Please Enter Login Password Again" />
        </li>

        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye3"><img :src="fristeyepic3" /></div>
          <input :type="fristtype3" v-model="password3" placeholder="Please Enter New Fund Password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye4"><img :src="fristeyepic4" /></div>
          <input :type="fristtype4" v-model="password4" placeholder="Please Enter Fund Password Again" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/share_icon_251215.png" /></div>
          <input type="text" v-model="inviteCode" v-on:input="in_code_input"
            placeholder="Please Enter Agent Invitation Code" />
        </li>
        <li>
          <button class="btn-submit" @click="submitbtn">Register</button>
        </li>
        <li>
          <div class="btn-other"><span>Already Has An Account?</span><span style="color:#1087e7" @click="util.topage('login')">Login Now</span></div>
        </li>
        <ul class="service_list">
          <!-- <li class="service_item" v-if="telegram_url.length > 1"  @click="to_service('telegram')">
            <img src="@/assets/images/base/img_tg.png" alt="">
          </li> -->
          <li class="service_item">
            <a :href="telegram_url" target="_blank">
              <img src="@/assets/images/base/img_tg.png" alt="">
            </a>
          </li>
          <li class="service_item" v-if="whatsapp_url.length > 1" @click="to_service('whatsapp')">
            <img src="@/assets/images/base/img_wa.png" alt="">
          </li>
        </ul>
        <div class="banquan" @click="callService">
          <!-- <div>Company Technology</div> -->
          <div>All Rights Reserved</div>
          <div>&copy;2008-2026</div>
        </div>
      </ul>
    </div>
    <van-loading v-show="!cheackpass" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
/*global mui*/
export default {
  data() {
    return {
      phone: "",
      email: "",
      password: "",
      password2: "",
      password3: "",
      password4: "",
      inviteCode: "",
      fristtype: "password",
      fristtype2: "password",
      fristtype3: "password",
      fristtype4: "password",
      fristeyepic: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      fristeyepic2: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      fristeyepic3: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      fristeyepic4: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      cheackpass: true,
      telegram_url: '',
      whatsapp_url: ''
    };
  },
  methods: {
    to_service(url) {
      if(url == 'telegram') {
        window.location.href = this.telegram_url
      } else {
        window.location.href = this.whatsapp_url
      }
    },
    get_service_url() {
      this.axios.get(this.api.api_findConfigs, {
        params: {
          names: "telegram,whatsapp",
        },
      }).then((res) => {
        this.telegram_url = res.data.data.telegram
        this.whatsapp_url = res.data.data.whatsapp
      })
        .catch((err) => {
          console.log(err);
        });
    },
    fristeye() {
      if (this.fristtype == "password") {
        this.fristtype = "text";
        this.fristeyepic = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype = "password";
        this.fristeyepic = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    fristeye2() {
      if (this.fristtype2 == "password") {
        this.fristtype2 = "text";
        this.fristeyepic2 = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype2 = "password";
        this.fristeyepic2 = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    fristeye3() {
      if (this.fristtype3 == "password") {
        this.fristtype3 = "text";
        this.fristeyepic3 = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype3 = "password";
        this.fristeyepic3 = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    fristeye4() {
      if (this.fristtype4 == "password") {
        this.fristtype4 = "text";
        this.fristeyepic4 = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype4 = "password";
        this.fristeyepic4 = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    submitbtn() {
      let Reg = /^[a-zA-Z][-_a-zA-Z0-9]{1,5}/;
      this.email = this.phone + '@gmail.com'
      if (this.phone.length < 1) {
        mui.alert("Account cannot be empty");
      } else if (this.phone.length < 5 || this.phone.length > 20 || !Reg.test(this.phone)) {
        mui.alert("Account must start with a letter and be between 5 and 20 in length");
      } else if (!this.password) {
        mui.alert("Password cannot be empty");
      } else if (this.password.length < 6) {
        mui.alert("Password must be more than six characters");
      } else if (this.password2 != this.password) {
        mui.alert("The two passwords don't match");
      } else if (!this.password3) {
        mui.alert("Pay password cannot be empty");
      } else if (this.password3.length < 6) {
        mui.alert("Pay password must be more than six characters");
      } else if (this.password3 != this.password4) {
        mui.alert("The two pay passwords don't match");
      } else if (this.inviteCode.length < 1) {
        mui.alert("invite code cannot be empty");
      } else if (this.cheackpass) {
        this.submitLogin();
      }

      // else if(!this.email) {
      //   mui.alert("Email cannot be empty");
      // }
    },
    trim(str) {
      return str.replace(/^\s+|\s+$/g, "");
    },
    in_code_input() {
      this.inviteCode = this.trim(this.inviteCode)
    },
    phone_input() {
      this.phone = this.trim(this.phone)
    },
    submitLogin() {
      this.cheackpass = false;
      let params = {
        phone: this.phone,
        email: this.email,
        password: this.password,
        payPassword: this.password3,
        inviteCode: this.inviteCode
      };
      this.util.setDnValue(params);
      this.axios.post(this.api.api_userRegister, this.util.encodeSearchParams(params)).then((res) => {
        this.cheackpass = true;
        if (res.data.code == 0) {
          mui.alert("register success");
          this.$router.push('login')
        } else {
          mui.alert(res.data.message);
        }
      }).catch(() => {
          this.cheackpass = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    callService() {
      // this.axios.get(this.api.api_findOneConfigByKeyName, {
      //   params: { key_name: "customer_service" }
      // }).then((res) => {
      //   if (res.data.code == 0) {
      //     window.location = res.data.data.key_value;
      //   }
      // }).catch((err) => {
      //   console.log(err);
      // });
    }
  },
  mounted() {
    this.get_service_url()
  },
  activated() {
    if (this.$route.query.invite_code != undefined && this.$route.query.invite_code != "") {
      this.inviteCode = this.$route.query.invite_code;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/login.scss";
</style>